import type { BoxProps } from "@mui/material/Box"
import Box from "@mui/material/Box"

import { NAV_PANEL_BG } from "@constants/colors"
import { LEFT_NAV_HEIGHT, LEFT_NAV_WIDTH } from "@constants/sizes"

export default function ItemContainer(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: LEFT_NAV_WIDTH,
        height: LEFT_NAV_HEIGHT,
        position: "relative",
        background: NAV_PANEL_BG,
        ...props?.sx
      }}
    />
  )
}
